<template>

<form @submit.prevent="onsubmit()">
  <loading :active.sync="loading.state" :is-full-page="false"></loading>
  <va-input
    v-model="payload.email"
    type="text"
    :label="$t('auth.email')"
    :errorMessages="[email_err]"
    :error="email_has_err"
  />
  <va-input
    v-model="payload.password"
    type="password"
    :label="$t('auth.password')"
    :errorMessages="[password_err]"
    :error="password_has_err"    
  />

  <div class="d-flex align--center justify--space-between">
    <va-checkbox v-model="payload.keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/>
    <router-link class="ml-1 link" style="color:#8d0c14;" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
  </div>

  <div class="d-flex justify--center mt-3">
    <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
  </div>
</form>
</template>

<script>

import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Validation from '../../../mixins/ValidationMixin';
import Events from '@/app/events.js'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {

  name: 'login',
  mixins: [Validation.Validation],
  components:{ Loading },

  data () {
    return {

      loading:{
        state: false,
        message: 'loading...',
        spinner: false,
        overlay: false
      },

      payload:{
        email:"",
        password:"",
        keepLoggedIn:""
      }
    }
  },

  computed: {

    ...Validation.mapValidationKeys([
        "email",
        "password"
    ]),

    ...mapState({
      user: state => state.user,
    }),

    ...mapGetters([
      'isAuthed'
    ]),

  },
  methods: {

    ...mapMutations({
      update: 'updateUserState',
      auth:'setUserAuthState'
    }),

    ...mapActions({
      login: 'authenticationAction'
    }),

    onsubmit () {

        this.loading.state = true
        this.login(this.payload, {headers: {'Content-Type': 'application/json'}}).then((response)=>{
          
          this.loading.state = false
          this.auth(true)
          Events.$emit('auth-success',response)

        }).catch( exeption => this.valErr = exeption,this.loading.state = false );

    },

  },

  created(){
    if( this.isAuthed ) this.$router.replace({ name: 'watchedItems' });
  }

}
</script>

